import { CanActivateChildFn } from '@angular/router';
import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

export const canActivateChildGuard: CanActivateChildFn = (
  childRoute,
  state,
) => {
  let matDialog = inject(MatDialog);
  if (matDialog.openDialogs.length > 0) {
    matDialog.closeAll();
    return false;
  } else {
    return true;
  }
};
